export const Metakeys = {
    type: "ng1-shift:type",
    componentOptions: "ng1-shift:componentOptions"
};
